












import { ClearCardViewStateMixin } from '@/mixins/clearViewStateMixin'
import { CloseViewLinkElInterface } from '@/config/interfaces'

export default ClearCardViewStateMixin.extend({
  name: 'CloseViewLinkEl',

  methods: {
    closeCard (e:Event): void {
      e.preventDefault()
      this.clearCardState()
      this.$router.back()
    }
  },

  props: {
    templateItemData: {
      type: Object as () => CloseViewLinkElInterface,
      required: true
    }
  }
})
